
import { AesDecrypt, AesEncrypt, keyPromise } from '../../Service/crypto'

import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, FormGroup, Label, Input, Button, Alert } from "reactstrap";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import MD5 from "crypto-js/md5"; // Import MD5 directly from its specific module
import { Password, RememberPassword, ForgotPassword } from '../../utils/Constant';
import webservice from '../../Service/webservice'; // Make sure to import this correctly
import { ensureBotRuntimeAuth } from '../../Service/botRuntimeService';
import MySwal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import api from '../../api';
import { AlertTriangle, LogOut } from 'react-feather';

interface FormData {
  password: string;
  loginEmail: string;
}

const defaultValues: FormData = {
  password: "",
  loginEmail: "",
};

interface LoginResponse {
  web_token: string;
  id: string;
  login_status: string;
  Pin: string;
  UserType: string;
  UserName: string;
  Client: string;
  ClientId: string;
  VendorId: string;
  emailId: string;
  MobileNo: string;
  Location: string;
  Role: string;
  RoleId: string;
  ability: any[];
  otp_enabled: boolean;
  mfa_token: string;
  mfa_secret: string;
  otpauth_url: string;
  is_two_factor_enabled: boolean;
}

interface NavigatorConnection extends Navigator {
  connection?: {
    effectiveType?: string;
    downlink?: number;
  };
}

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  // Only one session per user: the backend reports when the account is signed in elsewhere
  const [alreadyLoggedIn, setAlreadyLoggedIn] = useState<boolean>(false);
  // Why this browser was sent back to the login screen (set by api.ts)
  const [logoutReason] = useState<string>(() => {
    try {
      const reason = sessionStorage.getItem('logout_reason') || '';
      sessionStorage.removeItem('logout_reason');
      return reason;
    } catch {
      return '';
    }
  });
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);


  const [signInDisabled, setSignInDisabled] = useState<boolean>(false);
  const [commonError, setCommonError] = useState<string>("");
  const dispatch = useDispatch();
  const [networkSpeed, setNetworkSpeed] = useState<string | null>(null);
  const [ipData, setIpData] = useState("");
  const [browserName, setBrowserName] = useState("");
  const [osName, setOsName] = useState("");

  const { handleSubmit, control, setError, getValues, formState: { errors } } = useForm<FormData>({ defaultValues });

  // Getting ip address
  useEffect(() => {
    const getIp = () => {
      fetch('https://api.ipregistry.co/?key=ira_ArABTHEAuimffyMu5HfiZCI3PaLoBE3hT631')
        .then((response) => response.json())
        .then((data) => {
          setIpData(data.ip);
          setBrowserName(data.user_agent.name);
          setOsName(data.user_agent.os.name);
          const Time = data.time_zone.id;
          localStorage.setItem("timezone", Time);
        })
        .catch((error) => {
          console.error("Error fetching IP address:", error);
        });
    };
    getIp();
  }, []);

  // Setting user network speed
  useEffect(() => {
    const calculateNetworkSpeed = () => {
      const navigatorConnection = navigator as NavigatorConnection;
      if (navigatorConnection.connection) {
        const connection = navigatorConnection.connection;
        if (connection.downlink) {
          const downlinkSpeed = (connection.downlink * 8).toFixed(2);
          setNetworkSpeed(downlinkSpeed + " Mbps");
        }
      }
    };
    calculateNetworkSpeed();
  }, []);

  const userloghistory = async (UserLoginHistory: any) => {
    const key = await keyPromise;
    const EncParams = await AesEncrypt(key, UserLoginHistory);
    const response = await api.fetch('api/UserlogHistory/Userloginhistory_add', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    });
    return await response.json();
  };

  const Useractivelist = async (Useractivelist: any) => {
    const key = await keyPromise;
    const EncParams = await AesEncrypt(key, Useractivelist);
    const response = await api.fetch('api/ActiveUserList/Useractivelist_add', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    });
    return await response.json();
  };

  const onSubmit: SubmitHandler<FormData> = (formData) => submitLogin(formData, false);

  // forceLogin: the user confirmed signing the other device out
  const submitLogin = async (formData: FormData, forceLogin: boolean) => {
    setSignInDisabled(true);
    setIsSubmitting(true);
    setAlreadyLoggedIn(false);
    setCommonError("");
    try {
        const key = await keyPromise;
      if (Object.values(formData).every((field) => field.length > 0)) {
        const hashedPassword = MD5(formData.password).toString();
        const EncParams = await AesEncrypt(key, { loginEmail: formData.loginEmail, password: hashedPassword, forceLogin });
        const result = await fetch(webservice + "api/Authentication/login", {
          method: "POST",
          body: JSON.stringify({EncParams}),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const response = await result.json();
        const res = await AesDecrypt(key,response);       
        if (typeof res === "string" && res === "Invalid password") {
          setSignInDisabled(false);
          setIsSubmitting(false);
          setError("password",{message:"Please enter valid Password"});
        } else if (typeof res === "string" && res === "Invalid email or password") {
          setSignInDisabled(false);
          setIsSubmitting(false);
          setError("loginEmail",{message:"Please enter valid Email"});
          setError("password",{message:"Please enter valid Password"});
        } 
        else if (res && res.already_logged_in) {
          setAlreadyLoggedIn(true);
          setSignInDisabled(false);
          setIsSubmitting(false);
        }
        else if (!res || typeof res === "string" || res.error) {
          setCommonError(typeof res === "string" ? res : "Unable to sign in. Please try again.");
          setSignInDisabled(false);
          setIsSubmitting(false);
        }
        else if (res && res.must_change_password) {
          // Temporary password: the backend issues no session until it has been changed.
          sessionStorage.setItem("pwd_change_ctx", JSON.stringify({
            id: res.id,
            emailId: res.emailId,
            UserName: res.UserName,
            password_change_token: res.password_change_token,
          }));
          navigate(`/authentication/changepassword`, { replace: true });
        }
        else {
          {
            localStorage.setItem("UserType", res["UserType"]);
            localStorage.setItem("UserName", res["UserName"]);
            localStorage.setItem("FirstName", res["firstName"]);
            localStorage.setItem("LastName", res["lastName"]);
            localStorage.setItem("ClientName", res["Client"]);
            if (res["ClientId"] !== "") {
              localStorage.setItem("ClientId", res["ClientId"]);
            }
            if (res["VendorId"] !== "") {
              localStorage.setItem("VendorId", res["VendorId"]);
            }
            localStorage.setItem("emailId", res["emailId"]);
            localStorage.setItem("MobileNo", res["MobileNo"]);
            localStorage.setItem("Location", res["Location"]);
            localStorage.setItem("Role", res["Role"]);
            localStorage.setItem("RoleId", res["RoleId"]);
            localStorage.setItem("WebToken", res["web_token"]);
            localStorage.setItem("id", res["id"]);
            localStorage.setItem("ability", JSON.stringify(res["ability"]));
            localStorage.setItem("otp_enabled", res["otp_enabled"] ? "true" : "false");
            localStorage.setItem("is_two_factor_enabled", res["is_two_factor_enabled"] ? "true" : "false");
            localStorage.setItem("mfa_token", res["mfa_token"] || "");
            localStorage.setItem("mfa_secret", res["mfa_secret"] || "");
            localStorage.setItem("otpauth_url", res["otpauth_url"] || "");
            localStorage.setItem("token", res["token"] || "");
            localStorage.setItem("refresh_token", res["refresh_token"] || "");

            // Neither of these results is required to reach the dashboard, so they run in the
            // background instead of blocking navigation on them (the auth-health host in
            // particular has no response timeout, which was stalling login for 60s+).
            ensureBotRuntimeAuth(res["id"]).catch((error) => {
              console.error('Bot runtime login failed:', error);
            });

            (async () => {
              const authHost = 'http://192.168.0.108:8001';
              const controller = new AbortController();
              const timeoutId = setTimeout(() => controller.abort(), 5000);
              try {
                const triggerResult = await fetch(`${authHost}/auth-health`, {
                  method: 'POST',
                  body: JSON.stringify({ user_Id: res["id"], source: window.location.origin }),
                  headers: { 'Content-type': 'application/json; charset=UTF-8' },
                  signal: controller.signal,
                });
                const triggerResponse = await triggerResult.json();
                if (triggerResponse && triggerResponse.access_token) {
                  localStorage.setItem('helpchat_token', triggerResponse.access_token);
                }
              } catch (error) {
                console.error('HelpChat auth failed:', error);
              } finally {
                clearTimeout(timeoutId);
              }
            })();

            // Navigate to pin page only if two-factor authentication is enabled, otherwise go to dashboard
            if (res["is_two_factor_enabled"]) {
              navigate(`/authentication/pin`);
            } else {
              // Proceed with login directly to dashboard
              const username = res["UserName"];
              const userid = res["id"];
              const Usertype = res["UserType"];
              const UserIPAddress = ipData;
              const userBrowser = browserName;
              const userOsName = osName;
              const usernetspeed = networkSpeed;

              localStorage.setItem('login', JSON.stringify(true));
              window.dispatchEvent(new CustomEvent('auth_state_changed', { detail: { action: 'login', userId: res["id"] } }));
              navigate(`/dashboard`);

              // Log-history/active-list bookkeeping isn't needed to render the dashboard,
              // so it's dispatched to redux in the background once it resolves.
              (async () => {
                try {
                  const [result, activeListData] = await Promise.all([
                    userloghistory({ username, Usertype, userid, UserIPAddress, userBrowser, userOsName, usernetspeed }),
                    Useractivelist({ username, Usertype, userid, UserIPAddress, userBrowser, userOsName, usernetspeed }),
                  ]);

                  dispatch({ type: 'user/loghistory/fulfilled', payload: { logHistory: result, activeList: activeListData } });
                } catch (error) {
                  console.error('Error logging user history:', error);
                }
              })();
            }
          }
        }
      } else {
        setSignInDisabled(false);
        setIsSubmitting(false);

        for (const key in formData) {
          if (formData[key as keyof FormData].length === 0) {
            setError(key as keyof FormData, {
              type: "required",
              // message: "This field is required",
            });
          }
        }

      }
    } catch (err) {
      console.error(err);
      setCommonError("Unable to sign in. Please try again.");
      setSignInDisabled(false);
      setIsSubmitting(false);
    }
  };

  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xs={12} className="p-0">
          <div className="login-card login-dark">
            <div>
              <div className="login-main">
                <Form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
                  <h3>Sign In to Your Account</h3>
                  <p>Enter your email & password to login</p>
                  {logoutReason && !alreadyLoggedIn && (
                    <Alert color="warning" className="d-flex align-items-start" style={{ gap: 10 }}>
                      <AlertTriangle size={18} className="flex-shrink-0 mt-1" />
                      <span>
                        {logoutReason === 'session_replaced'
                          ? 'Your session has ended because this account was signed in on another device. Please sign in again.'
                          : 'Your session has expired. Please sign in again.'}
                      </span>
                    </Alert>
                  )}
                  <FormGroup>
                    <Label className="col-form-label">Email Address</Label>
                    <Controller
                      name="loginEmail"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <>
                          <Input
                            type="email"
                            required
                            invalid={errors.loginEmail && true}
                            placeholder="Enter your Email"
                            {...field}
                          />
                          {errors.loginEmail &&  <div className="text-danger">{errors.loginEmail.message}</div>}
                          {errors.loginEmail && errors.loginEmail.type === 'required' && (
                              <div className="text-danger">Please enter Your Email</div>
                            )}
                        </>
                      )}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{Password}</Label>
                    <div className="form-input position-relative">
                      <Controller
                        name="password"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <>
                            <Input
                              type={show ? "text" : "password"}
                              placeholder="*********"
                              invalid={errors.password && true}
                              {...field}
                            />
                              {errors.password &&  <div className="text-danger">{errors.password.message}</div>}
                            {errors.password && errors.password.type === 'required' && (
                              <div className="text-danger">Please enter a Password</div>
                            )}
                       
                          </>
                        )}
                      />
                      {!errors.password && (<div className="show-hide">
                  <span onClick={() => setShow(!show)} className={!show ? "show" : ""}/>
                </div>)}
                    </div>
                  </FormGroup>
                  {alreadyLoggedIn && (
                    <Alert color="danger">
                      <div className="d-flex align-items-center" style={{ gap: 10 }}>
                        <AlertTriangle size={18} className="flex-shrink-0" />
                        <span>Already logged in on another device</span>
                      </div>
                      <Button
                        color="danger"
                        size="sm"
                        type="button"
                        className="w-100 mt-2 d-flex align-items-center justify-content-center"
                        style={{ gap: 8 }}
                        disabled={isSubmitting}
                        onClick={() => submitLogin(getValues(), true)}
                      >
                        <LogOut size={14} /> Sign out other device &amp; sign in here
                      </Button>
                    </Alert>
                  )}
                  {commonError && <Alert color="danger">{commonError}</Alert>}
                  <FormGroup className="mb-0 form-sub-title">
                  <div className="checkbox p-0">
                      <Input id="checkbox1" type="checkbox" />
                      {/* <Label className="text-muted" htmlFor="checkbox1">{RememberPassword}</Label> */}
                    </div> 
                    <Link className="link" to={`/authentication/forgetpassword`} >{ForgotPassword} </Link>
                    <div className="text-end mt-3">
                      <Button color="primary" className="btn-block w-100" type="submit" disabled={signInDisabled}>
                        {isSubmitting ? (
                          <img src="../assets/images/ajax-loader.gif" alt="Loading..." />
                        ) : (
                          'Sign In'
                        )}
                      </Button>
                    </div>
                  </FormGroup>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;